import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkPriceLockup, UitkPriceLockupAlign } from 'uitk-react-price-lockup';
import { UitkText } from 'uitk-react-text';
import { getPriceDetails } from '../../../../../../business';
import { ActivityCancellationType, ActivityDestinationViewSearch } from '../../../../../../common/__generated__/api';
import { ActivityFeature } from '../components/activity-feature';

export interface ActivityCardContentBottomProps {
  activity: ActivityDestinationViewSearch.ActivityInlineFragment;
}

export const ActivityCardContentBottom = ({ activity }: ActivityCardContentBottomProps): JSX.Element => {
  const {
    strikeOutFormattedPrice,
    leadFormattedPrice,
    leadFormattedPoints,
    leadPriceLabel,
    priceAccessibilityText
  } = getPriceDetails(activity);

  return (
    <>
      <UitkLayoutFlex tag="section" direction="column" data-testid="activity-tile-card-content-bottom">
        {activity.features.freeCancellation?.type === ActivityCancellationType.FREE_CANCELLATION && (
          <UitkLayoutFlexItem className="all-b-margin-one">
            <UitkText size={200} theme="positive" data-testid="activity-free-cancellation">
              {activity.features.freeCancellation.formatted}
            </UitkText>
          </UitkLayoutFlexItem>
        )}
        {activity.features.loyaltyEarnAwards && (
          <UitkLayoutFlexItem className="uitk-type-300 color-accent-3 all-b-margin-one">
            <ActivityFeature
              label={activity.features.loyaltyEarnAwards.label}
              mark={activity.features.loyaltyEarnAwards.mark}
              data-testid="loyalty-earn-award--feature"
            />
          </UitkLayoutFlexItem>
        )}
        <UitkLayoutFlexItem>
          <UitkPriceLockup
            align={UitkPriceLockupAlign.LEFT}
            a11yPrice={priceAccessibilityText || ''}
            lockupFormattedPoints={leadFormattedPoints || undefined}
            lockupPrice={leadFormattedPrice ? leadFormattedPrice : undefined}
            priceSubtextStandard={leadPriceLabel ? leadPriceLabel : undefined}
            strikeThroughPrice={strikeOutFormattedPrice ? strikeOutFormattedPrice : undefined}
          />
        </UitkLayoutFlexItem>
        {activity.leadTicket.taxesAndFeesMessage && (
          <UitkLayoutFlexItem className="all-t-margin-one">
            <UitkText size={200} data-testid="activity-taxes-and-fees-message">
              {activity.leadTicket.taxesAndFeesMessage}
            </UitkText>
          </UitkLayoutFlexItem>
        )}
        {activity.features.volumePricing?.description && (
          <UitkLayoutFlexItem className="all-t-margin-one">
            <UitkText size={100} data-testid="activity-volume-based-pricing">
              {activity.features.volumePricing.description}
            </UitkText>
          </UitkLayoutFlexItem>
        )}
        {activity.features.likelyToSellOut?.formatted && (
          <UitkLayoutFlexItem className="all-t-margin-one">
            <UitkText size={200} theme="negative" data-testid="activity-likely-to-sell-out">
              {activity.features.likelyToSellOut.formatted}
            </UitkText>
          </UitkLayoutFlexItem>
        )}
      </UitkLayoutFlex>
    </>
  );
};
